import React, { useContext } from "react";
import { BrowserRouter } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";

import Body from "./Body";
import NavBar from "./NavBar";

import navItems from "../Shared/nav.json";
import { GlobalStyle } from "../Shared/GlobalStyle";
import { lightTheme, darkTheme } from "../Shared/theme";
import AppContext from "../Contexts/AppContext";

const App: React.FC = () => {
  const { appState } = useContext(AppContext);

  return (
    <ThemeProvider theme={appState.theme.isDark ? darkTheme : lightTheme}>
      <GlobalStyle />
      <Wrapper>
        <BrowserRouter>
          <Body />
          <NavBar items={navItems} />
        </BrowserRouter>
      </Wrapper>
    </ThemeProvider>
  );
};

const Wrapper = styled.div`
  min-height: calc(100vh - 140px);
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 20px 10px 120px 10px;
`;

export default App;
